const accordions = document.querySelectorAll('.block-accordion');

accordions.forEach((accordion) => {
    const accordionItems = accordion.querySelectorAll('.accordion-item');

    accordionItems.forEach((accordionItem) => {
        const accordionItemTitle = accordionItem.querySelector('.accordion__item-title');

        accordionItemTitle.addEventListener('click', () => {
            if (accordionItem.classList.contains('is-open')) {
                accordionItem.classList.remove('is-open');
            } else {
                const accordionTitlesWithIsOpen = accordion.querySelectorAll('.is-open');
                accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
                    accordionTitleWithIsOpen.classList.remove('is-open');
                });
                accordionItem.classList.add('is-open');
            }
        });
    });
});
